import React from 'react'
import { Grid, TextField, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core'

export const FormLacreRetorno = (props) => {
  const { form, maxLength250 } = props

  return (
    <Grid container spacing={2}>
      <Grid item md={3} sm={6} xs={12} style={{ marginBottom: '16px' }}>
        <TextField
          error={form.hasError('lacre')}
          helperText={form.hasError('lacre') ? form.formState.errors.lacre[0] : null}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
          label="NÚMERO DO LACRE"
          name="lacre"
          onChange={(e) => form.handleChangeWithModification(e, maxLength250)}
          value={form.formState.values.lacre || ''}
          multiline
        />
        <Typography variant="caption">Caracteres restantes: {250 - (form.formState.values.lacre?.length ? form.formState.values.lacre.length : 0)}</Typography>
      </Grid>

      <Grid item container md={12} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px' }}>TIPO DA EMBALAGEM</Typography>
        </Grid>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup aria-label="tipo-embalagem" name="tipoEmbalagem" value={form.formState.values.tipoEmbalagem || null} onChange={form.handleChange} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            <FormControlLabel value="SACO LACRE" control={<Radio color="primary" />} label={<Typography variant="body2">SACO LACRE</Typography>} />
            <FormControlLabel value="PLÁSTICO" control={<Radio color="primary" />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
            <FormControlLabel value="ENVELOPE PAPEL" control={<Radio color="primary" />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
            <FormControlLabel value="CAIXA" control={<Radio color="primary" />} label={<Typography variant="body2">CAIXA</Typography>} />
            <FormControlLabel value="AUSENTE" control={<Radio color="primary" />} label={<Typography variant="body2">AUSENTE</Typography>} />
            <FormControlLabel value="OUTRO" control={<Radio color="primary" />} label={<Typography variant="body2">OUTRO</Typography>} />
          </RadioGroup>
        </FormControl>
        <Grid item md={12} sm={12} xs={12} style={{ marginTop: '8px' }}>
          <TextField
            label="OUTRO TIPO DE EMBALAGEM"
            name="outroTipoEmbalagem"
            variant="outlined"
            value={form.formState.values.outroTipoEmbalagem || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.tipoEmbalagem !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>

      <Grid item container md={12} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px' }}>COR DA EMBALAGEM</Typography>
        </Grid>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup aria-label="cor-embalagem" name="corEmbalagem" value={form.formState.values.corEmbalagem || null} onChange={form.handleChange} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            <FormControlLabel value="TRANSPARENTE" control={<Radio color="primary" />} label={<Typography variant="body2">TRANSPARENTE</Typography>} />
            <FormControlLabel value="BRANCA" control={<Radio color="primary" />} label={<Typography variant="body2">BRANCA</Typography>} />
            <FormControlLabel value="AMARELA" control={<Radio color="primary" />} label={<Typography variant="body2">AMARELA</Typography>} />
            <FormControlLabel value="CINZA" control={<Radio color="primary" />} label={<Typography variant="body2">CINZA</Typography>} />
            <FormControlLabel value="PRETA" control={<Radio color="primary" />} label={<Typography variant="body2">PRETA</Typography>} />
            <FormControlLabel value="N/A" control={<Radio color="primary" />} label={<Typography variant="body2">N/A</Typography>} />
            <FormControlLabel value="OUTRO" control={<Radio color="primary" />} label={<Typography variant="body2">OUTRO</Typography>} />
          </RadioGroup>
        </FormControl>
        <Grid item md={12} sm={12} xs={12} style={{ marginTop: '8px' }}>
          <TextField
            label="OUTRA COR DE EMBALAGEM"
            name="outraCorEmbalagem"
            variant="outlined"
            value={form.formState.values.outraCorEmbalagem || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.corEmbalagem !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>

      <Grid item container md={12} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px' }}>TIPO DE FECHO</Typography>
        </Grid>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup aria-label="tipo-fecho" name="tipoFecho" value={form.formState.values.tipoFecho || null} onChange={form.handleChange} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            <FormControlLabel value="FILME" control={<Radio color="primary" />} label={<Typography variant="body2">FILME</Typography>} />
            <FormControlLabel value="NÓ" control={<Radio color="primary" />} label={<Typography variant="body2">NÓ</Typography>} />
            <FormControlLabel value="ZIP LOCK" control={<Radio color="primary" />} label={<Typography variant="body2">ZIP LOCK</Typography>} />
            <FormControlLabel value="GRAMPO" control={<Radio color="primary" />} label={<Typography variant="body2">GRAMPO</Typography>} />
            <FormControlLabel value="LACRE" control={<Radio color="primary" />} label={<Typography variant="body2">LACRE </Typography>} />
            <FormControlLabel value="NÃO INFORMADO" control={<Radio color="primary" />} label={<Typography variant="body2">NÃO INFORMAR</Typography>} />
            <FormControlLabel value="OUTRO" control={<Radio color="primary" />} label={<Typography variant="body2">OUTRO</Typography>} />
          </RadioGroup>
        </FormControl>
        <Grid item md={12} sm={12} xs={12} style={{ marginTop: '8px' }}>
          <TextField
            label="OUTRO TIPO DE FECHO"
            name="outroTipoFecho"
            variant="outlined"
            value={form.formState.values.outroTipoFecho || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.tipoFecho !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>

      <Grid item container md={12} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px' }}>APRESENTA LOGOMARCA OU DESENHO ILUSTRATIVO</Typography>
        </Grid>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup aria-label="logomarca" name="logomarca" value={form.formState.values.logomarca || null} onChange={form.handleChange} style={{ display: 'flex', flexDirection: 'row' }}>
            <FormControlLabel value="SIM" control={<Radio color="primary" />} label={<Typography variant="body2">SIM</Typography>} />
            <FormControlLabel value="NAO" control={<Radio color="primary" />} label={<Typography variant="body2">NÃO</Typography>} />
          </RadioGroup>
        </FormControl>
        <Grid item md={12} sm={12} xs={12} style={{ marginTop: '8px' }}>
          <TextField
            label="DESCRIÇÃO DA LOGOMARCA OU DESENHO"
            name="tipoLogomarca"
            variant="outlined"
            value={form.formState.values.tipoLogomarca || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.logomarca !== 'SIM'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
